import axios from 'axios';
import { API_url } from '../api.setup';
import { SalesPartnerEarningModel } from 'src/models/salesPartner/SalesPartnerEarningModel';

const API_Controller = '/salespartner';

const SalesPartnerService = {
  getAllSalesPartners: async (): Promise<any[]> => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getallSalesPartner`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSalesPartners: async (id: number): Promise<any> => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getSalesPartner/get?id=${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  addSalesPartner: async (agentData: {
    name: string;
    contactNo: string;
    referral?: string;
    isActive?: boolean;
  }): Promise<any> => {
    try {
      const response = await axios.post(`${API_url}${API_Controller}/createSalesPartner`, agentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateSalesPartner: async (agentData: {
    id: number;
    name: string;
    contactNo: string;
    referral?: string;
    isActive: boolean;
    isDeleted: boolean;
  }): Promise<any> => {
    try {
      const response = await axios.put(`${API_url}${API_Controller}/updateSalesPartner`, agentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteSalesPartner: async (id: number): Promise<void> => {

    try {

      await axios.delete(`${API_url}${API_Controller}/deleteSalesPartner/${id}`);
    } catch (error) {
      throw error;
    }
  },

  earningData: async (salesPartnerId: number, startDate: string, endDate: string) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getSalesPartnerEarningByDateRange`, {
        params: {
          salesPartnerId,
          startDate,
          endDate
        }
      });

      return response.data as SalesPartnerEarningModel;
    } catch (error) {
      console.error("Earror fetching earning data", error);
      throw error;
    }
  },
  getMyAppDownloadsData: async (salesPartnerId: number, startDate: string, endDate: string) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getSalesPartnerAppDownloadsByDateRange?salesPartnerId=${salesPartnerId}&startDate=${startDate}&endDate=${endDate}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching app downloads data:", error);
      throw error;
    }
  },
  GetPendingInquiries: async (salesPartnerId: number) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getAllCustomerInquiresBySalesPartnerId?salesPartnerId=${salesPartnerId}`
      );
      const data = response.data;
      return Array.isArray(data) ? data : [data];
    } catch (error) {
      console.error("Error fetching pending inquiries:", error);
      throw error;
    }
  },

  getSalesPartnerSettlementBalance: async (salesPartnerId: number, date: string) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getSalesPartnerSettlementBalance`,
        { params: { salesPartnerId, date } }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching settlement balance:", error);
      throw error;
    }
  },

  
}
export default SalesPartnerService;